import React, { useState, useEffect, useRef } from 'react';
import { func, string, number } from 'prop-types';
import useStyles from 'hooks/useStyles';
import cx from 'classnames';

import styles from './MultilineTextField.scss';

const MultilineTextField = ({
  label,
  placeholder,
  value,
  onChange,
  maxRows,
}) => {
  useStyles(styles);
  const inputRef = useRef();
  const [inputHeight, setInputHeight] = useState('auto');

  const inputBorderWidth = 1;
  const inputPaddingTopAndBottom = 4;
  const lineHeight = 26;
  const maxHeight = lineHeight * maxRows + inputPaddingTopAndBottom * 2;

  useEffect(() => {
    if (!inputRef.current && !value) return;

    const { scrollHeight } = inputRef.current;
    const newInputHeight =
      scrollHeight <= maxHeight ? scrollHeight + inputBorderWidth : maxHeight;
    setInputHeight(newInputHeight);
  }, [value, maxHeight]);

  const handleChange = e => {
    // Init inputRef.current origin height
    setInputHeight('auto');
    onChange(e.target.value);
  };

  return (
    <div className={styles.root}>
      <textarea
        ref={inputRef}
        style={{
          height: inputHeight,
          borderBottomWidth: inputBorderWidth,
          paddingTop: inputPaddingTopAndBottom,
          paddingBottom: inputPaddingTopAndBottom,
        }}
        className={styles.input}
        onChange={handleChange}
        placeholder={placeholder}
        rows={1}
      >
        {value}
      </textarea>
      <span
        className={cx(styles.label, {
          [styles.floating]: value || placeholder,
        })}
      >
        {label}
      </span>
    </div>
  );
};

MultilineTextField.propTypes = {
  value: string.isRequired,
  onChange: func.isRequired,
  maxRows: number.isRequired,
  label: string,
  placeholder: string,
};

MultilineTextField.defaultProps = {
  label: null,
  placeholder: null,
};

export default MultilineTextField;
